import React from 'react';
import { isMobileOnly } from "react-device-detect";

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

//mobile select start
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//mobile select end

import LangNavLink from 'components/lang/LangNavLink';
require("styles/components/common/page-side-menu.scss");


  const PageSideMenu = ({ current, ...data }) => {
  const menuLinks = data?.data?.links;
  console.log(menuLinks)
  const isMobile = isMobileOnly;
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  //dropdown select
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="page-side-menu">
        
      { !isMobile > 0 &&
        <List component="nav" aria-label="">
          {
            menuLinks && Object.keys(menuLinks).map((key, pos) => {
              return (
                <ListItem button key={pos+1} onClick={(event) => handleListItemClick(event, pos+1)} component={LangNavLink} to={menuLinks[key].link.url} >
                    <ListItemText primary={menuLinks[key].link.title}/>
                    <ListItemIcon>
                      <NavigateNextIcon />
                    </ListItemIcon>
                </ListItem>
              );
            })
          }
        </List>
      }
      

      {isMobile > 0 && window.location.href.indexOf("media") > -1 &&
        <div className="select-cal">
          
          {
            Object.keys(menuLinks).slice(0,1).map((key, pos) => {
              return (
                <Button key={pos} onClick={handleClick} variant="contained" fullWidth size="large" endIcon={<ExpandMoreIcon/>}>
                  {menuLinks[key].link.title}
                </Button>
              );
            })
          }
          <Menu
            className="select-opts"
            anchorEl={anchorEl}
            // keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            elevation={0}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            getContentAnchorEl={null}
          > 
            {
              Object.keys(menuLinks).map((key, pos) => {
                return (
                  <MenuItem key={pos+1} onClick={handleClose} component={LangNavLink} to={menuLinks[key].link.url}>
                    <span className="desc">
                      {menuLinks[key].link.title}
                    </span>
                  </MenuItem>
                );
              })
            }
          </Menu>
        </div>
      }
      {isMobile > 0 && window.location.href.indexOf("media") <= 0 &&
        <div className="select-cal">
          
          <Button onClick={handleClick} variant="contained" fullWidth size="large" endIcon={<ExpandMoreIcon/>}>
            {current}
          </Button>
          <Menu
            className="select-opts"
            anchorEl={anchorEl}
            // keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            elevation={0}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            getContentAnchorEl={null}
          > 
            {
              Object.keys(menuLinks).map((key, pos) => {
                return (
                  <MenuItem key={pos+1} onClick={handleClose} component={LangNavLink} to={menuLinks[key].link.url}>
                    <span className="desc">
                      {menuLinks[key].link.title}
                    </span>
                  </MenuItem>
                );
              })
            }
          </Menu>
        </div>
      }

    </div>
  );
}

export default PageSideMenu;